/* eslint-disable no-restricted-syntax */
import {useState} from 'react';
import {Button, TextField, Dialog, DialogContent, DialogActions, DialogContentText, Divider} from '@mui/material';
import DialogTitleWithClose from 'components/Generic/DialogTitle';
import {useTranslation} from 'react-i18next';

export function EditFolderNameDialog({
  open,
  currentName,
  handleClose,
  handleCreate,
  ...props
}: {
  open: boolean;
  currentName: string;
  handleClose: () => void;
  handleCreate: (name) => void;
}) {
  const {t} = useTranslation('common');
  const [name, setName] = useState<string>(currentName);

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="edit-folder-name-dialog" maxWidth="sm" {...props}>
      <DialogTitleWithClose onClose={handleClose}>{t('editFolderName')}</DialogTitleWithClose>
      <Divider />
      <DialogContent>
        <DialogContentText pb={2}>{t('editFolderNameDialogText')}</DialogContentText>
        <TextField
          variant="outlined"
          autoFocus
          margin="dense"
          id="name"
          label={t('folderName')}
          type="text"
          fullWidth
          defaultValue={name}
          onChange={(event) => {
            setName(event.target.value);
          }}
          error={name === ''}
          helperText={name === '' ? t('emptyFolderName') : ''}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" size="small">
          {t('cancel')}
        </Button>
        <Button
          onClick={() => {
            handleCreate(name);
            handleClose();
          }}
          type="submit"
          color="primary"
          variant="contained"
          size="small"
          disabled={!name}
        >
          {t('save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
